import { render, staticRenderFns } from "./ModerationBlock.vue?vue&type=template&id=2bac1d2e&"
import script from "./ModerationBlock.vue?vue&type=script&lang=js&"
export * from "./ModerationBlock.vue?vue&type=script&lang=js&"
import style0 from "./ModerationBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports